<sans-play-toolbar [gamePlayId]="gamePlayId"></sans-play-toolbar>

<div class="container">
  <ng-container *ngIf="isGamePlayFetchedAtLeastOnce">
    <sans-dealing-cards
      (timerExpired)="onDealingCardsTimerExpired()"
      *ngIf="gameStatus === 'DealingCards'"
    ></sans-dealing-cards>

    <sans-bidding
      [biddingGame]="biddingGame"
      [userPlayerScoreCard]="userPlayerScoreCard"
      [leftOpponentPlayerScoreCard]="leftOpponentPlayerScoreCard"
      [rightOpponentPlayerScoreCard]="rightOpponentPlayerScoreCard"
      (gameUpdated)="onGameUpdated()"
      *ngIf="gameStatus === 'Bidding'"
    ></sans-bidding>

    <sans-contract-declaration
      [contractDeclarationGame]="contractDeclarationGame"
      [userPlayerScoreCard]="userPlayerScoreCard"
      [leftOpponentPlayerScoreCard]="leftOpponentPlayerScoreCard"
      [rightOpponentPlayerScoreCard]="rightOpponentPlayerScoreCard"
      (gameUpdated)="onGameUpdated()"
      *ngIf="gameStatus === 'ContractDeclaration'"
    ></sans-contract-declaration>

    <sans-defender-declaration
      [defenderDeclarationGame]="defenderDeclarationGame"
      [userPlayerScoreCard]="userPlayerScoreCard"
      [leftOpponentPlayerScoreCard]="leftOpponentPlayerScoreCard"
      [rightOpponentPlayerScoreCard]="rightOpponentPlayerScoreCard"
      (gameUpdated)="onGameUpdated()"
      *ngIf="gameStatus === 'DefenderDeclaration'"
    ></sans-defender-declaration>

    <sans-playing-game
      [playingGame]="playingGame"
      [userPlayerScoreCard]="userPlayerScoreCard"
      [leftOpponentPlayerScoreCard]="leftOpponentPlayerScoreCard"
      [rightOpponentPlayerScoreCard]="rightOpponentPlayerScoreCard"
      (gameUpdated)="onGameUpdated()"
      *ngIf="gameStatus === 'Playing'"
    >
    </sans-playing-game>

    <sans-settling
      [settlingGame]="settlingGame"
      [userPlayerScoreCard]="userPlayerScoreCard"
      [leftOpponentPlayerScoreCard]="leftOpponentPlayerScoreCard"
      [rightOpponentPlayerScoreCard]="rightOpponentPlayerScoreCard"
      (gameUpdated)="onGameUpdated()"
      *ngIf="gameStatus === 'Settling'"
    >
    </sans-settling>

    <sans-completed-game
      (timerExpired)="onCompletedGameTimerExpired()"
      *ngIf="shouldShowCompletedGame"
    ></sans-completed-game>

    <sans-game-play-results
      *ngIf="gamePlayStatus === 'Completed'"
      [gamePlayId]="gamePlayId"
      [user]="user"
      [rightOpponent]="rightOpponent"
      [leftOpponent]="leftOpponent"
      [userPlayerScoreCard]="userPlayerScoreCard"
      [rightOpponentPlayerScoreCard]="rightOpponentPlayerScoreCard"
      [leftOpponentPlayerScoreCard]="leftOpponentPlayerScoreCard"
    ></sans-game-play-results>
  </ng-container>
</div>
